import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = {
  key: 1,
  class: "flex items-center cursor-pointer w-fit"
}
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "ml-2" }

import { useI18n } from "vue-i18n";
import SelectList from "shared/components/other/OaiListbox.vue";
import { MilestoneReportConfig, MilestoneReportFilters } from "@/types/reports/PlotMilestone";


export default /*#__PURE__*/_defineComponent({
  __name: 'MilestoneConfigFields',
  props: {
    config: {},
    filters: {}
  },
  emits: ["configChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const modes = [
  { value: "sequence", name: t("analytics.reports.sequence_mode") },
  { value: "end_date", name: t("analytics.reports.end_date_mode") },
];

const variants = [
  { value: "milestone", name: t("analytics.reports.milestone_variant") },
  { value: "progress_curve", name: t("analytics.reports.progress_curve") },
];

const handleModeChange = (newMode: string) => {
  emit("configChange", {
    ...props.config,
    mode: newMode as MilestoneReportConfig["mode"],
  });
};

const handleVariantChange = (newVariant: string) => {
  emit("configChange", {
    ...props.config,
    variant: newVariant as MilestoneReportConfig["variant"],
  });
};

const handleShowDeltaChange = (event: Event) => {
  const inputElement = event.currentTarget as HTMLInputElement;
  emit("configChange", {
    ...props.config,
    show_delta: inputElement.checked,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SelectList, {
      options: variants,
      name: "variant",
      defaultSelected: _ctx.config.variant,
      label: _unref(t)('analytics.reports.plot_type'),
      "onUpdate:selected": handleVariantChange
    }, null, 8, ["defaultSelected", "label"]),
    (_ctx.config.variant === 'milestone')
      ? (_openBlock(), _createBlock(SelectList, {
          key: 0,
          options: modes,
          name: "mode",
          defaultSelected: _ctx.config.mode,
          label: _unref(t)('analytics.reports.sort_modes'),
          "onUpdate:selected": handleModeChange
        }, null, 8, ["defaultSelected", "label"]))
      : _createCommentVNode("", true),
    (_ctx.config.variant === 'milestone' || _ctx.filters.location.length === 0)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "h-4 w-4 rounded border-gray-300 text-yellow-500 focus:ring-yellow-500 cursor-pointer",
            checked: _ctx.config.show_delta,
            onChange: handleShowDeltaChange
          }, null, 40, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("analytics.reports.show_delta")), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})